import { getCar, getCars } from '../reducers'
import { selectCar } from "../actions"
import { connect } from 'react-redux'
import {
    Box, Icon,
    Container,
    Card, CardHeader, CardBody, Stack, StackDivider,
    Text,
    Flex,
    Button,
    Heading,
    SimpleGrid,
    Image,
    Tabs, TabList, TabPanels, Tab, TabPanel,
    List, ListItem, ListIcon
} from '@chakra-ui/react'
import Layout from '../layout'
import CarPreview from "../components/CarPreview"
import asesor from '../multimedia/imagenes/asesor.jpg'
import CarouselMulti from 'react-multi-carousel'
import { IoMdCheckmarkCircle } from 'react-icons/io'
import { ChevronLeftIcon, ChevronRightIcon } from '@chakra-ui/icons'
import CarCard from "../components/CarCard"


const responsive = {
    largeDesktop: {
        breakpoint: { max: 3000, min: 1400 },
        items: 3,
        partialVisibilityGutter: 30
    },
    desktop: {
        breakpoint: { max: 1400, min: 1024 },
        items: 3,
        partialVisibilityGutter: 30
    },
    tablet: {
        breakpoint: { max: 1024, min: 464 },
        items: 2,
        partialVisibilityGutter: 30
    },
    mobile: {
        breakpoint: { max: 464, min: 0 },
        items: 1,
        partialVisibilityGutter: 30
    }
};

const CustomRightArrow = ({ onClick, ...rest }) => {
    return <Button onClick={() => onClick()} style={{
        position: "absolute", outline: 0, transition: "all .5s", zIndex: 1000, opacity: 1, cursor: "pointer", border: 0, background: "rgba(0,0,0,0.7)", right: "0", height: "100%"
    }}>
        <Icon as={ChevronRightIcon} color={"white"} boxSize={8} />
    </Button>
}

const CustomLeftArrow = ({ onClick, ...rest }) => {
    return <Button onClick={() => onClick()} style={{
        position: "absolute", outline: 0, transition: "all .5s", zIndex: 1000, opacity: 1, cursor: "pointer", border: 0, background: "rgba(0,0,0,0.7)", left: "0", height: "100%"
    }}>
        <Icon as={ChevronLeftIcon} color={"white"} boxSize={8} />
    </Button>
}

const CarDetail = (props) => {


    const { car, cars, selectCar } = props

    const pickCar = () => {
        selectCar(car.id)
    }

    let i = 0
    return (
        <Layout>
            <Container maxW={'7xl'}>

                <Flex maxW={"1400px"} flexDir={{ base: 'column', lg: 'row' }} p={4} m={"auto"} marginTop={"20px"} marginBottom={"7rem"} gap={"10px"}>
                    <CarPreview car={car} />

                    <Card marginTop={{ base: "4rem", md: 0 }}>
                        <CardHeader>
                            <Heading>{car.cMarca} {car.cModelo} {car.nAnio} </Heading>
                        </CardHeader>
                        <CardBody>
                            <Stack divider={<StackDivider />} spacing='4'>
                                <Text>{car.nMillaje.toLocaleString('en-US')} Millas</Text>
                                <Text>Precio de venta ${car.nPrecioVenta.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })} + IVA</Text>
                                <Text>Anticipo desde: {(car.nAnticipo * 100).toLocaleString('en-US')}%</Text>
                                <a
                                    href={`https://wa.me/+50372900087?${car.cUTM}&${encodeURIComponent(`text=Me interesa adquirir el vehículo en arrendamiento financiero y pagarlo mensualmente`)}`}
                                    target={"_blank"}
                                    rel="noreferrer">
                                    <Button colorScheme="easycar1" variant='outline' w={'full'} size={'lg'} py={'7'} _hover={{ transform: 'translateY(2px)', boxShadow: 'lg', }} >Contacta a un ejecutivo</Button>
                                </a>
                                <Text>Año {car.nAnio} </Text>
                                <Text>Modelo {car.cModelo}</Text>
                                <Text>{car.cAgencia}</Text>
                                <a
                                    href={`https://wa.me/+50372900087?${car.cUTM}&${encodeURIComponent(`text=Me interesaría adquirir el vehículo al contado.`)}`}
                                    target={"_blank"}
                                    rel="noreferrer">
                                    <Button colorScheme="easycar1" w={'full'} size={'lg'} py={'7'} _hover={{ transform: 'translateY(2px)', boxShadow: 'lg', }}>Llévatelo a contado</Button>
                                </a>
                            </Stack>
                        </CardBody>
                    </Card>
                </Flex>

                <Box w={"100%"} p={5} textAlign={"center"} marginTop={"20px"} marginBottom={"20px"}>
                    <Text m={"auto"} color={"black"} textAlign={"justify"}>
                        Imágenes referenciales. El precio publicado corresponde a pago de contado, no incluye IVA. El precio del vehículo bajo contrato de arrendamiento financiero puede variar según plazo y las condiciones en las que se tome el contrato. Sujeto a evaluación y aprobación. El anticipo del arrendamiento financiero podrá variar de acuerdo con la categoría del vehículo y segmento del cliente establecida en políticas internas y valor base del vehículo. Precios válidos hasta agotar existencias. Vehículos usados. La propiedad del vehículo se transferirá al cliente de forma exclusiva al ejercer la opción de compra a la finalización del contrato de arrendamiento financiero, conforme a los términos estipulados en el mismo. Para más información consulte con su ejecutivo o visite su agencia más cercana.
                    </Text>


                </Box>
                <Box bg={"easycar1.500"} w={"100%"} p={5} textAlign={"center"} marginTop={"20px"} marginBottom={"20px"} >
                    <Text m={"auto"} as={"b"} fontSize={"4xl"} color={"white"}>¡Te damos garantía certificada!</Text>
                </Box>

                <Box textAlign={"center"} w={"full"} mb={"10px"} marginTop={"20px"}>
                    <Text as={"b"} fontSize={"3xl"} textTransform={'uppercase'} >Características</Text>
                </Box>
                <SimpleGrid
                    columns={{ sm: 2, md: 3 }}
                    marginTop={"20px"} marginBottom={"20px"}
                    padding={6}
                    spacing={10}
                >
                    <Box>
                        <Text as={"b"}>Marca</Text>
                        <hr />
                        <Text> {car.cMarca} </Text>
                    </Box>
                    <Box>
                        <Text as={"b"}>Modelo</Text>
                        <hr />
                        <Text> {car.cModelo}</Text>
                    </Box>
                    <Box>
                        <Text as={"b"}>Año</Text>
                        <hr />
                        <Text> {car.nAnio}</Text>
                    </Box>
                    <Box>
                        <Text as={"b"}>Color</Text>
                        <hr />
                        <Text>{car.cColor}</Text>
                    </Box>
                    <Box>
                        <Text as={"b"}>Recorrido</Text>
                        <hr />
                        <Text> {car.nMillaje.toLocaleString('en-US')} Millas</Text>
                    </Box>
                    <Box>
                        <Text as={"b"}>Accesorios de ruedas</Text>
                        <hr />
                        <Text>{car.cRinesCopas}</Text>
                    </Box>
                    <Box>
                        <Text as={"b"}>Motor</Text>
                        <hr />
                        <Text>{car.cMotor}</Text>
                    </Box>
                    <Box>
                        <Text as={"b"}>Caja</Text>
                        <hr />
                        <Text>{car.cCaja}</Text>
                    </Box>
                    <Box>
                        <Text as={"b"}>Accesorios</Text>
                        <hr />
                        <Text>{car.cAccesorios}</Text>
                    </Box>
                    <Box>
                        <Text as={"b"}>Tracción</Text>
                        <hr />
                        <Text>{car.cTraccion}</Text>
                    </Box>
                </SimpleGrid>

                <Box w={"full"} >
                    <Flex bg={"easycar1.500"} maxW={"1400px"} flexDir={{ base: 'column', md: 'row' }} p={4} m={"auto"} color={"white"} marginTop={"20px"} marginBottom={"20px"}>
                        <Box width={{ base: 'full', md: "50%" }} padding={4}>
                            <Heading>Adquiere tu vehículo hasta en 60 meses</Heading>
                            <br />
                            <Text>Obtén tu plan de pago en estos momentos.</Text>
                            <Text>Sube toda la información requerida para brindarte la oferta.</Text>
                            <br />
                            <a
                                href={`https://wa.me/+50372900087?${car.cUTM}&${encodeURIComponent(`text=Me interesa adquirir el vehículo en arrendamiento financiero y pagarlo mensualmente`)}`}
                                target={"_blank"}
                                rel="noreferrer">
                                <Button colorScheme="easycar2">Contacta a un ejecutivo</Button>
                            </a>
                        </Box>
                        <Box width={{ base: 'full', md: "50%" }}>
                            <Image src={asesor} width={"full"} rounded={6} maxH={"350px"} objectFit='cover' />
                        </Box>
                    </Flex>
                </Box>

                <Box textAlign={"center"} w={"full"} mb={"10px"} marginTop={"30px"}>
                    <Text as={"b"} fontSize={"3xl"} >Requisitos mínimos para que obtengas el vehículo de tus sueños</Text>
                </Box>

                <Tabs variant='soft-rounded' colorScheme='easycar1' padding="10px" mt="7.5rem" mb="2rem">
                    <TabList justifyContent="center">
                        <Tab>En arrendamiento financiero</Tab>
                        <Tab>De Contado</Tab>
                    </TabList>

                    <TabPanels>
                        {/* TAB DE ARRENDAMIENTO FINANCIERO */}
                        <TabPanel fontSize="xl">
                            {/* Texto IVA centrado */}
                            <Box textAlign="center" mb="6" fontWeight="bold" color="red.500">
                                El precio publicado no incluye IVA
                            </Box>

                            {/* Columnas para cada tipo de persona */}
                            <SimpleGrid columns={[1, 2, 3]} spacing={6}>
                                <Box>
                                    <Text fontWeight="semibold" mb="2">Persona Natural No Contribuyente</Text>
                                    <List>
                                        <ListItem><ListIcon as={IoMdCheckmarkCircle} color='green.500' />DUI</ListItem>
                                        <ListItem><ListIcon as={IoMdCheckmarkCircle} color='green.500' />NIT</ListItem>
                                        <ListItem><ListIcon as={IoMdCheckmarkCircle} color='green.500' />Monto de anticipo</ListItem>
                                    </List>
                                    <Text mt="2" color="gray.600" fontSize="md">
                                        Nota: Si desea aplicar con un monto de anticipo menor al publicado, deberá presentar comprobante de ingreso.
                                    </Text>
                                </Box>

                                <Box>
                                    <Text fontWeight="semibold" mb="2">Persona Natural Contribuyente</Text>
                                    <List>
                                        <ListItem><ListIcon as={IoMdCheckmarkCircle} color='green.500' />NIT del contribuyente</ListItem>
                                        <ListItem><ListIcon as={IoMdCheckmarkCircle} color='green.500' />DUI</ListItem>
                                        <ListItem><ListIcon as={IoMdCheckmarkCircle} color='green.500' />Monto de anticipo</ListItem>
                                    </List>
                                    <Text mt="2" color="gray.600" fontSize="md">
                                        Nota: Si desea aplicar con un monto de anticipo menor al publicado, deberá presentar comprobante de ingreso.
                                    </Text>
                                </Box>

                                <Box>
                                    <Text fontWeight="semibold" mb="2">Persona Jurídica</Text>
                                    <List>
                                        <ListItem><ListIcon as={IoMdCheckmarkCircle} color='green.500' />Credencial de representante legal</ListItem>
                                        <ListItem><ListIcon as={IoMdCheckmarkCircle} color='green.500' />Documentación de la empresa</ListItem>
                                        <ListItem><ListIcon as={IoMdCheckmarkCircle} color='green.500' />Monto de anticipo</ListItem>
                                    </List>
                                    <Text mt="2" color="gray.600" fontSize="md">
                                        Nota: Si desea aplicar con un monto de anticipo menor al publicado, deberá presentar comprobante de ingreso.
                                    </Text>
                                </Box>
                            </SimpleGrid>
                        </TabPanel>

                        {/* TAB DE OPCIÓN DE CONTADO */}
                        <TabPanel fontSize="xl">
                            {/* Texto IVA centrado */}
                            <Box textAlign="center" mb="6" fontWeight="bold" color="red.500">
                                El precio publicado no incluye IVA
                            </Box>

                            {/* Columnas para cada tipo de persona */}
                            <SimpleGrid columns={[1, 2, 3]} spacing={6}>
                                <Box>
                                    <Text fontWeight="semibold" mb="2">Persona Natural Contribuyente</Text>
                                    <List>
                                        <ListItem><ListIcon as={IoMdCheckmarkCircle} color='green.500' />NIT del contribuyente</ListItem>
                                        <ListItem><ListIcon as={IoMdCheckmarkCircle} color='green.500' />DUI</ListItem>
                                        <ListItem><ListIcon as={IoMdCheckmarkCircle} color='green.500' />Monto total</ListItem>
                                        <ListItem><ListIcon as={IoMdCheckmarkCircle} color='green.500' />Comprobación u origen de los fondos</ListItem>
                                    </List>
                                </Box>

                                <Box>
                                    <Text fontWeight="semibold" mb="2">Persona Jurídica</Text>
                                    <List>
                                        <ListItem><ListIcon as={IoMdCheckmarkCircle} color='green.500' />Credencial de representante legal</ListItem>
                                        <ListItem><ListIcon as={IoMdCheckmarkCircle} color='green.500' />Documentación de la empresa</ListItem>
                                        <ListItem><ListIcon as={IoMdCheckmarkCircle} color='green.500' />Monto total</ListItem>
                                        <ListItem><ListIcon as={IoMdCheckmarkCircle} color='green.500' />Comprobación u origen de los fondos</ListItem>
                                    </List>
                                </Box>

                                <Box>
                                    <Text fontWeight="semibold" mb="2">Persona Natural No Contribuyente</Text>
                                    <List>
                                        <ListItem><ListIcon as={IoMdCheckmarkCircle} color='green.500' />DUI</ListItem>
                                        <ListItem><ListIcon as={IoMdCheckmarkCircle} color='green.500' />NIT</ListItem>
                                        <ListItem><ListIcon as={IoMdCheckmarkCircle} color='green.500' />Monto total</ListItem>
                                        <ListItem><ListIcon as={IoMdCheckmarkCircle} color='green.500' />Comprobación u origen de los fondos</ListItem>
                                    </List>
                                </Box>
                            </SimpleGrid>
                        </TabPanel>
                    </TabPanels>
                </Tabs>



                <Box textAlign={"center"} w={"full"} mb={"10px"} marginTop={"20px"}>
                    <Text as={"b"} fontSize={"3xl"} >Autos similares</Text>
                </Box>

                <CarouselMulti showDots={false} infinite={false} responsive={responsive} partialVisible={true} customRightArrow={<CustomRightArrow />} customLeftArrow={<CustomLeftArrow />} >
                    {cars.filter(carSimilar => {
                        if (carSimilar.id === car.id) return false
                        if (i === 0) return true
                        else {
                            if (Math.random() < 0.5) return false
                            else return true
                        }
                    }).map(carSimilar => {
                        if (i <= 4) {
                            i++
                            return <CarCard car={carSimilar} key={carSimilar.id} pickCar={pickCar} />
                        }
                        return undefined
                    }
                    )}
                </CarouselMulti>

                <Box textAlign={"center"} w={"full"} mb={"10px"} marginTop={"20px"}></Box>

            </Container>
        </Layout>
    )
}

const mapStateToProps = (state, ownProps) => ({
    car: getCar(state, ownProps.match.params.id),
    cars: getCars(state)
})

const mapDispatchToProps = { selectCar }

export default connect(mapStateToProps, mapDispatchToProps)(CarDetail)